module.exports = __webpack_public_path__ + "img/listItem6.1c77af2a.png";